var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$mq},[(_vm.isRightMoveTo)?_c('v-touch',{staticClass:"left",on:{"swiperight":_vm.onSwipeRight}}):_vm._e(),_vm._t("default"),(_vm.isLeftMoveTo)?_c('v-touch',{staticClass:"right",on:{"swipeleft":_vm.onSwipeLeft}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }